/**
 * E-belge platformunun geçmiş yanıtını ({ states, actions, emails }) tek bir zaman
 * çizelgesine çevirir — kesilen ve gelen belgede aynı biçim. En yeni olay önce.
 */

export interface HistoryEvent {
  at: string;
  kind: "state" | "action" | "email";
  title: string;
  detail?: string;
  /** İşlem / e-posta sonucu; durum geçişinde tanımsız. */
  ok?: boolean;
}

const STATE_NAMES: Record<string, string> = {
  Draft: "Taslak",
  Validated: "Doğrulandı",
  Queued: "Kuyrukta",
  SentToProvider: "Entegratöre iletildi",
  ProviderAccepted: "Entegratör kabul etti",
  GibAccepted: "GİB kabul etti",
  Delivered: "Teslim edildi",
  WaitingApplicationResponse: "Yanıt bekleniyor",
  AcceptedByBuyer: "Alıcı kabul etti",
  RejectedByBuyer: "Alıcı reddetti",
  Cancelled: "İptal edildi",
  Objected: "İtiraz edildi",
  Failed: "Başarısız",
};

export const documentStateName = (state?: string | null) => (state ? STATE_NAMES[state] || state : "—");

const actionTitle = (kind?: string, method?: string) => {
  if (kind === "ApplicationResponse") return method === "RED" ? "Red yanıtı" : "Kabul yanıtı";
  if (kind === "Cancel") return "İptal";
  if (kind === "Objection") return method ? `İtiraz (${method})` : "İtiraz";
  return kind || "İşlem";
};

export const flattenHistory = (history: any): HistoryEvent[] => {
  if (!history) return [];

  const events: HistoryEvent[] = [];

  for (const s of history.states ?? []) {
    events.push({
      at: s.at,
      kind: "state",
      title: documentStateName(s.to),
      detail: [s.from ? `${documentStateName(s.from)} →` : null, s.rawStatus].filter(Boolean).join(" "),
    });
  }

  for (const a of history.actions ?? []) {
    events.push({
      at: a.at,
      kind: "action",
      title: actionTitle(a.kind, a.method),
      detail: [a.description, a.errorMessage, a.performedBy].filter(Boolean).join(" · "),
      ok: a.succeeded,
    });
  }

  for (const e of history.emails ?? []) {
    events.push({
      at: e.at,
      kind: "email",
      title: `E-posta: ${e.address}`,
      detail: [e.remark, e.requestedBy].filter(Boolean).join(" · "),
      ok: e.succeeded,
    });
  }

  return events.sort((x, y) => new Date(y.at).getTime() - new Date(x.at).getTime());
};
